module.exports = __webpack_public_path__ + "img/b11.e69cfa60.png";